<template>
  <div>
    <div
      class="d-flex flex-column"
      v-if="!isInCorruptedState"
      :class="{ 'vh-100': $runtimeEnvironment.isMobile }"
    >
      <mobile-header
        v-if="$runtimeEnvironment.isMobile && !isLandscape"
        :cart-items-count="cartItemsCount"
      ></mobile-header>

      <portal-target name="side-b-modal"> </portal-target>

      <portal-target name="add-to-catalog-modal"> </portal-target>

      <portal-target name="save-to-cart-modal"> </portal-target>

      <div
        class="mx-auto px-5 d-flex justify-content-center flex-column mt-3"
        v-if="isMobileOnly && isLandscape"
      >
        <img
          :src="`${$pathPrefix}/assets/mobile-landscape.svg`"
          height="200"
          class="img-fluid"
        />
        <p class="text-secondary font-weight-bold text-center">
          Bitte drehen Sie Ihr Telefon, da der Konfigurator für das Hochformat
          optimiert wurde!
        </p>
      </div>
      <div class="bg-white d-flex h-100 flex-column" v-else>
        <notifications
          class="z-9999"
          group="app"
          position="top right"
          width="250"
          close-on-click
          classes="vue-notification mt-12 mr-3 z-9999"
        >
        </notifications>

        <!-- <nav class="sk_breadcrumb  mt-md-2 mb-md-4" :class="{
            'mt-5': !isNavBarVisible
          }">
          <a href="/">{{ $t('homepage')}}</a>
          <a href="/config" v-if="isNavBarVisible">Product Designer</a>
          <a href="/config/vnext" v-if="isNavBarVisible">{{ $t('configurator') }}</a>
          <a v-if="$route.name !== 'home'" :href="`/config/vnext/${$route.name}`">{{ $t($route.name) }}</a>
        </nav> -->
        <nav
          class="sk_breadcrumb mt-md-2 mb-md-4"
          :class="{ 'mt-5': !isNavBarVisible }"
        >
          <!-- Show all links normally if not digikey -->
          <template v-if="!isDigikeySource">
            <a href="/">{{ $t("homepage") }}</a>
            <a href="/config" v-if="isNavBarVisible">Product Designer</a>
            <a href="/config/vnext" v-if="isNavBarVisible">{{
              $t("configurator")
            }}</a>
            <a
              v-if="$route.name !== 'home'"
              :href="`/config/vnext/${$route.name}`"
              >{{ $t($route.name) }}</a
            >
          </template>

          <!-- Show only last two links if digikey -->
          <template v-else>
            <a href="/config/vnext" v-if="isNavBarVisible">{{
              $t("configurator")
            }}</a>
            <a
              v-if="$route.name !== 'home'"
              :href="`/config/vnext/${$route.name}`"
              >{{ $t($route.name) }}</a
            >
          </template>
        </nav>

        <portal-target
          name="progression-steps"
          class="d-none d-lg-flex progression-steps"
        >
          <slot />
        </portal-target>

        <navigation-bar v-if="!$runtimeEnvironment.isMobile" />
        <transition mode="out-in" name="fade">
          <router-view
            class="border-left border-right border-bottom border-configurator h-100"
            id="configurator-inner"
          />
        </transition>
      </div>
    </div>
    <div class="text-danger" v-else>
      <p>Something went wrong on initialization</p>
    </div>
  </div>
</template>

<script>
import NavigationBar from "./components/NavigationBar";
import MobileHeader from "./components/MobileHeader";
import Cookie from "js-cookie";

import { mapState } from "vuex";

export default {
  name: "App",
  components: {
    NavigationBar,
    MobileHeader,
  },
  async mounted() {
    //<---------  set source in localstorage to manage digikey users
    // Get query parameters from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const source = urlParams.get("source"); // Extract 'source' parameter

    // Store in localStorage only if source is exactly 'digikey'
    if (source === "digikey") {
      localStorage.setItem("userSource", source);
    }
    //<---------End----------------------
    this.$runtimeEnvironment.onResize((state) =>
      state === "landscape"
        ? (this.isLandscape = true)
        : (this.isLandscape = false)
    );

    try {
      let { success, /* error, */ userData } =
        await this.$shopApiClient.getCurrentUserInfo();

      // ToDo: get rid of the emcom-go-dw2
      if (
        success === true ||
        window.location.hostname.indexOf("emcom-go-dw2") >= 0
      ) {
        this.$store.commit("setState", {
          stateKey: "loggedIn",
          data:
            window.location.hostname.indexOf("emcom-go-dw2") >= 0
              ? true
              : success,
        });
        this.$store.commit("setState", {
          stateKey: "discount",
          data:
            (userData && userData.usergroup && userData.usergroup.discount) ||
            0,
        });
        this.$store.commit("setState", {
          stateKey: "surcharge",
          data:
            (userData && userData.usergroup && userData.usergroup.surcharge) ||
            21,
        });
        this.$store.commit("setState", {
          stateKey: "showPrice",
          data: (userData && userData.show_price) || false,
        });

        this.$store.state.features.fetchProductNumberEnabled = true;

        // redirect to main shop page if the use has vnext disabled
        if (!userData.config_vnext.enabled) window.location.href = "/";

        // set available configurator types in logged in state
        if (this.$store.state.loggedIn === true) {
          this.$store.commit("setState", {
            stateKey: "enabledConfiguratorTypes",
            data: {
              patchcord: userData.config_vnext.types.patchcord.enabled || false,
              fanout: userData.config_vnext.types.fanout.enabled || false,
              breakout: userData.config_vnext.types.breakout.enabled || false,
              trunk: userData.config_vnext.types.trunk.enabled || false,
              fbgs: userData.config_vnext.types.fbgs.enabled || false,
            },
          });

          // product should be added to a project
          this.$store.commit("setState", {
            stateKey: "projectAddProduct",
            data: !!Cookie.get("project_add_product"),
          });

          // store user info for error tracking
          this.$store.commit("setState", {
            stateKey: "userData",
            data: {
              id: userData.id,
              username: userData.username,
              customerNunmer: userData.customer_num,
              industries: userData.industries.map((i) => parseInt(i)),
            },
          });

          // checks the dataCenter value to control shadow properties like
          // Kabelmarkierungstülle YA06
          this.$store.commit("setState", {
            stateKey: "getsDataCenterProducts",
            data: userData.config_vnext.datacenter || false,
          });

          // user gets new catalog?
          this.$store.commit("setState", {
            stateKey: "getsNewCatalog",
            data: userData.usergroup.use_pricegroup_new
              ? userData.usergroup.use_pricegroup_new == 1
                ? true
                : false
              : false,
          });

          if (
            this.$store.state.getsNewCatalog &&
            userData.pricegroup_surcharge &&
            !isNaN(userData.pricegroup_surcharge)
          )
            this.$store.commit("setState", {
              stateKey: "surcharge",
              data: parseInt(userData.pricegroup_surcharge),
            });

          // get cart info
          try {
            let { cart } = await this.$shopApiClient.getCart();
            this.$store.state.cartItemsCount = cart.count || 0;
          } catch (e) {
            this.$rollbar.warn(`could not fetch cart data allthough logged in`);
          }
        }
      }
    } catch (error) {
      this.$rollbar.error(error);
      this.$router.push("/");
    }

    this.$nextTick(() => {
      this.widthListener = window.addEventListener("resize", this.trySetWidth);
      this.trySetWidth();
    });

    if (this.$route.query.load) {
      let { error, vnext_data } = await this.$shopApiClient.getCable({
        id: this.$route.query.load,
      });
      if (!error && vnext_data) {
        // set data to store
        //eslint-disable-next-line
        // console.log(data)

        // if (data.partsList.plugsA.length <= 2) this.$router.push('/patch-cord')

        this.$nextTick(() => {
          Object.entries(vnext_data).forEach(([key, value]) => {
            this.$store.commit("setState", { stateKey: key, data: value });
          });
        });

        this.$store.commit("setState", {
          stateKey: "loadedProduct",
          data: true,
        });

        if (vnext_data.configuratorType)
          this.$router.push(vnext_data.configuratorType);
      }
      return;
    }

    if (this.$route.query.respecify && parseInt(this.$route.query.respecify)) {
      this.$store.commit("setState", {
        stateKey: "respecifyId",
        data: this.$route.query.respecify,
      });

      let { success, config } = await this.$shopApiClient.getCable({
        id: parseInt(this.$route.query.respecify),
      });

      if (success) {
        let oldConfigData = [
          // product type
          { key: "Produkttyp", value: config.type.name },
          // length
          { key: "Länge", value: `${config.type.length} m` },
          // options without plugs
          ...config.options
            .filter(({ type }) => type === "select")
            .map((option) => ({ key: option.name, value: option.value })),
          // plugs to plugs side a and side b
          ...config.options
            .filter(({ type }) => type == "plugs")[0]
            .plugs.map((plug, index) => ({
              key: `Stecker ${index === 0 ? "A" : "B"}`,
              value: `${plug.count}x ${plug.name} ${plug.type}`,
            })),
        ];
        this.$store.commit("setState", {
          stateKey: "respecifyData",
          data: oldConfigData,
        });
      }
    }
    if (this.$route.query.bestseller) {
      try {
        let vnext_data = await this.$shopApiClient.getBestsellerData(
          this.$route.query.bestseller
        );
        this.$nextTick(() => {
          Object.entries(vnext_data).forEach(([key, value]) => {
            this.$store.commit("setState", { stateKey: key, data: value });
          });
        });
        if (vnext_data.configuratorType)
          this.$router.push(vnext_data.configuratorType);

        this.$store.commit("setState", {
          stateKey: "loadedProduct",
          data: true,
        });
      } catch (e) {
        this.$rollbar.warn(
          `can't load bestseller with id ${this.$route.query.bestseller}`,
          e
        );
      }
    }
    if (window.location.hostname.indexOf("emcom-go-dw2") >= 0)
      this.$store.commit("setState", { stateKey: "loggedIn", data: true });
  },

  methods: {
    seedData(seedDataFromAttributes) {
      let dataAttributesAsObject = Object.assign({}, seedDataFromAttributes);

      // eslint-disable-next-line
      // console.log(seedDataFromAttributes, dataAttributesAsObject)

      Object.entries(dataAttributesAsObject)
        .filter(([key]) => key.indexOf("configuratorSeed") === 0)
        .forEach(([key, value]) => {
          let strippedKey = key.replace("configuratorSeed", "");
          let dataObject = JSON.parse(value);

          Object.entries(dataObject).forEach(([iKey, iValue]) => {
            this.$store.commit("setFilter", {
              filterKey: strippedKey,
              propertyName: iKey,
              propertyValue: iValue,
            });
          });
        });
    },
    trySetWidth() {
      this.$nextTick(() => {
        try {
          this.clientWidth = document.querySelector(".container").clientWidth;
        } catch (e) {
          this.$rollbar.error("can not find .container", e);
        }
      });
    },
    configureSurvicate() {
      // configure some user data
      if (this.$store.state.loggedIn) {
        window._sva.setVisitorTraits({
          shopUserId: this.$store.state.userData.id,
          shopUserName: this.$store.state.userData.username,
        });
      }

      if (this.$runtimeEnvironment.isMobile) {
        window._sva.addEventListener("survey_closed", () => {
          this.$store.commit("setState", {
            stateKey: "mobileSurvicateLoaded",
            data: false,
          });
        });

        window._sva.addEventListener("survey_displayed", () => {
          this.$store.commit("setState", {
            stateKey: "mobileSurvicateLoaded",
            data: true,
          });
        });
      }
    },
  },
  computed: {
    isDigikeySource() {
      return localStorage.getItem("userSource") === "digikey";
    },
    ...mapState(["isInCorruptedState", "cartItemsCount"]),
    isNavBarVisible: () => process.env.NODE_ENV === "production",
  },
  data() {
    return {
      clientWidth: 0,
      widthListener: null,
      isLandscape: this.$runtimeEnvironment.isLandscape,
      isMobileOnly: this.$runtimeEnvironment.isMobileOnly,
      inAppTimer: null,
    };
  },
  beforeDestroy() {
    document.removeEventListener(`resize`, this.trySetWidth);
  },
};
</script>

<style lang="scss">
.bg-light-green {
  background-color: $light-green;
}

.sk_breadcrumb a:first-child {
  background-color: $darker-eee;
}

#app {
  // font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-family: "Merriweather Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

// .progression-steps {
//   min-height: 85px;
// }

.bg-saka-orange {
  background-color: $saka-orange;
}

.bg-saka-green {
  background-color: $saka-green;
}

.bg-saka-light-green {
  background-color: $saka-orange;
}

.border-configurator {
  border-color: #eee !important;
}

.clickable {
  cursor: pointer;
}

.clickable.disabled {
  pointer-events: none;
  cursor: not-allowed;
}
.underline {
  text-decoration: underline;
}
.font-weight-bold {
  font-weight: bold;
}

.text-xs {
  font-size: 0.75em;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.custom-control:not(.ios) {
  font-size: 0.9rem;
  line-height: 1.8;
}

.custom-control.ios {
  padding-left: 0;
}
.custom-control.ios .custom-control-label {
  padding-right: 3rem;
  position: relative;
}
.custom-control.ios .custom-control-label::before {
  top: 0rem;
  right: 0;
  left: auto;
  width: 2.5rem;
  height: 1.5rem;
  border-radius: 0.75rem;
}

/*   */
.custom-control.ios .custom-control-label::after {
  content: "";
  height: 1em;
  width: 1em;
  left: auto;
  right: 1.25rem;
  transition: all 300ms;
  border-radius: 100%;
  background: #ccc;
  display: block;
}

.custom-control.ios
  .custom-control-input:checked
  ~ .custom-control-label::after {
  content: "";
  height: 1em;
  width: 1em;
  left: auto;
  right: 0.25rem;
  border-radius: 100%;
  background: $saka-green;
  transition: all 300ms;
  display: block;
}

.custom-control.ios
  .custom-control-input:checked
  ~ .custom-control-label::before {
  background: #dee2e6;
}

.custom-control.ios label > i {
  width: 1.5rem;
  height: 1.5rem;
}
.custom-control-input:checked ~ .custom-control-label::before {
  border-color: $saka-green;
  background-color: $saka-green;
}

.custom-checkbox-2::before {
  font-family: "Font Awesome 5 Free";
  display: inline-block;
  padding: 0px 3px;
  vertical-align: middle;
  font-weight: 900;
  border: 2px solid $dark-grey;
  border-radius: 3px;
  color: $saka-green;
  margin-bottom: 4px;
  content: " ";
  width: 1.5rem;
  height: 1.6rem;
}
.custom-checkbox-2.checked::before {
  content: "\f00c";
}

.bg-light-grey {
  background-color: $light-grey;
}

.plug-checkbox {
  background-color: transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.plug-checkbox > input[type="checkbox"] {
  width: 1.75em;
  height: 1.75em;
  margin-right: 0.5rem;
  appearance: none;
  border: 2px solid grey;
  border-radius: 3px;
}
.plug-checkbox > input[type="checkbox"]:checked::after {
  color: $saka-green;
  content: "";
  display: block;
  width: 1.75em;
  height: 1.75em;
  background-image: url("./assets/fa-check.svg");
  background-size: 1.2rem 1.2rem;
  background-repeat: no-repeat;
  background-position: 0.125em 0.125em;
}

textarea {
  resize: none;
}

.data-sheet-download {
  background-color: $saka-grey;
  color: white;
}

.data-sheet-download:disabled {
  background-color: grey;
  color: lightgrey !important;
  pointer-events: none;
}

.preview-data-sheet {
  color: $saka-grey;
}

#app .btn-sm > i {
  margin-right: 0.5em;
}

/* Chrome, Safari, Edge, Opera */
input.arrowless-number-input::-webkit-outer-spin-button,
input.arrowless-number-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"].arrowless-number-input {
  -moz-appearance: textfield;
}

a:hover {
  text-decoration: none !important;
}

/* check mark on cable or scroll select */
/* needed to place it in App.vue to not mess with relative paths in prod and dev */
.item-wrapper.active::after {
  content: "";
  background-image: url("./assets/fa-check.svg");
  background-size: 1.25rem 1.25rem;
  background-repeat: no-repeat;
  background-position: 0.2rem 0.2rem;
  background-color: $light-green;
  top: calc(-100px - 1em);
  position: relative;
  left: calc(100px - 1em);
  border: 1.5px solid $saka-green;
  border-radius: 99em;
  width: 2em;
  height: 2em;
  display: inline-block;
}

.z-9999 {
  z-index: 9999;
}

.mt-12 {
  margin-top: 12em !important;
}
.vue-dialog-buttons > button {
  flex-shrink: 0 !important;
  height: auto !important;
}

@media (max-width: 768px) {
  .fixed-footer-block {
    min-height: 10em;
  }
}

@media (max-width: 1024px) {
  .main-head {
    display: none;
    height: 0px;
  }

  .sk_breadcrumb {
    display: none;
  }

  .container {
    padding: 0;
  }

  footer.main {
    display: none;
  }

  div.nonFooter > header {
    display: none;
  }

  body {
    /* Disables pull-to-refresh but allows overscroll glow effects. */
    /* Only in production. Definition in vue.config.js */
    @if $PROD == true {
      overscroll-behavior-y: contain;
    }
  }
}

.fixed-footer-block {
  min-height: 6em;
}
</style>
